import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const loginQuery = createApi({
  baseQuery,
  reducerPath: "loginQueries",
  endpoints: (builder) => ({
    loginUser: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.loginUser)}`,
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(data),
      }),
    }),
    registerUser: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.userManagement.registerUser)}`,
        method: "POST",
        body: data,
      }),
    }),
    logout: builder.mutation<any, any>({
      query: ({ email }) => ({
        url: `${
          (formatString(endPoints.userManagement.deleteUser),
          {
            key: urlKeys.email,
            value: email,
          })
        }`,
        method: "POST",
      }),
    }),
  }),
});

export const { useLoginUserMutation, useRegisterUserMutation } = loginQuery;
